<template>
  <div class="header">
    <div class="header-top">
      <ul class="flex_row">
        <li><a href="http://wx.jiangdu.gov.cn">平台首页</a></li>
        <li class="flex_row">
          <div
            class="flex_row_center click-enter"
            @click="handlerEnter"
          >
            <span>无形资产十大子平台</span>
            <p class="flex_column">
              <span />
              <span />
              <span />
            </p>
          </div>  
        </li>         
      </ul>
    </div> 
    <div
      v-show="isShow"
      class="header-container"
      @mouseleave="handlerLeave"
    >
      <div>
        <ul>
          <li
            v-for="site in sites"
            :key="site.name"
          >
            <a
              :href="site.url"
              target="_blank"
              :title="site.name"
            >{{ site.name }}</a>
          </li>
        </ul>
      </div>       
    </div> 
  </div>
</template>

<script>
export default {
  data(){
    return{
      isShow:false,
      sites:[
        {name:'无形资产综合服务平台',url:'http://zhfw.wx.jiangdu.gov.cn/'},
        {name:'无形资产交易运营平台',url:'http://zlyy.wx.jiangdu.gov.cn/'},
        {name:'无形资产大数据可视化平台',url:'http://dsj.wx.jiangdu.gov.cn/'},
        {name:'无形资产信息数据库平台',url:'http://wxzck.wx.jiangdu.gov.cn/'},
        {name:'无形资产企业管理平台',url:'http://wx.jiangdu.gov.cn/uc'},
        {name:'无形资产金融服务平台',url:'http://jrfw.wx.jiangdu.gov.cn'},
        {name:'无形资产价值评估平台',url:'http://jzpg.wx.jiangdu.gov.cn'},
        {name:'无形资产奖励平台',url:'http://wx.jiangdu.gov.cn/uc/#/welcome'},
        {name:'专利产品平台',url:'http://zlcp.wx.jiangdu.gov.cn'},
        {name:'全球专利搜索平台',url:"http://zljs.wx.jiangdu.gov.cn"}
      ]
    }
  },
  methods:{
    handlerEnter(){
      this.isShow = true;
    },
    handlerLeave(){
      this.isShow = false;
    }
  }
}
</script>

<style lang='scss' scoped>
  .header{
    width:100%;
    height:46px;
    font-size:12px;
    color:#fff;
    background-color:#317cd0;  
    position:relative;   
    >div{
      width:1418px;
      margin:0 auto;
      a{
        font-size:14px;
        color:#fff;
        display: inline-block;
        padding-left:20px;
        cursor: pointer;
        &:hover{
          text-decoration: none;
        }
      }  
      ul{
        height:100%;
        list-style: none;
        display:flex;
        flex-direction: row;
        align-items: center;
      }  
    } 

    .header-top{
      height:100%;
      li{
        justify-content: center;
        align-items: center;
        padding-left:20px;
        position:relative;
        &:nth-child(2){         
          // overflow:hidden;
          // transition: all 0.2s;
          // &:hover .header-container{
          //   display:block;
          // }
          p{
            padding-left:4px;
            span{
                display:inline-block;
                width: 11px;
                height: 2px;
                background:#fff;
                margin:1px 0;
            }
          }
        }
       
      }
    }    
    .header-container{
      background-color: #235b9a;
      width:100%;
      height:85px;
      // display:none;
      position: absolute;
      top:46px;
      left:0; 
      padding: 10px 0;
      box-sizing: border-box;
      >div{
        width:1000px;
        margin:0 auto;
        ul{
          display: unset;
          li{
            display: inline-block;
            width:20%;
            padding:0;  
            line-height:30px; 
            a:hover{
              text-decoration: underline;
            }    
          }    
        }
      }  
    }
    .click-enter{
      cursor: pointer;
    }
  }
</style>